import { useRef, useState } from "react";
import { Modal, message } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { processSync } from "../../../../Sync/syncData";
import { getWorkflowData } from "../../../../../utils/getWorkflowData";
import { unlinkTill } from "../../../../../services";
import db from "../../../../../database";
import HCPrint from "../../../../../lib/printer/hardWareControllerPrinter";
import CWHCPrint from "../../../../../lib/printer/CWHardwareController";
import { xmlPrint } from "../../../../../lib/printer/xmlPrinter";
import { htmlPrint } from "../../../../../lib/printer/htmlPrinter";
import msgData from "../../../../../errors/messages.en-IN.json";
import { buildLockedSignInUrl } from "../../../../../constants/oAuthValidation";
import useSyncProgressStore from "../../../../../stores/useSyncProgressStore";
import usePOSConfigStore from "../../../../../stores/usePOSConfigStore";
import useSessionStore from "../../../../../stores/useSessionStore";
import useTransactionStore from "../../../../../stores/useTransactionStore";
import useCartStore from "../../../../../stores/useCartStore";
import useAuthStore from "../../../../../stores/useAuthStore";
import { trace } from "../../../../../utils/debugTrace";
import { showNextPaymentPage, cyclePaymentMethod, modulo } from "../paymentPaging";

const useSuperMarketActions = ({
  cart,
  setCart,
  tillData,
  posConfig,
  posConfigData,
  pricePrecision,
  keyboard,
  setOpen,
  setKeyValue,
  setSelectedKeys,
  setSelectedPaymentMethod,
  filterdParkedList,
  setFilterdParkedList,
  showOrderHistory,
  setSyncLoad,
  selectedSaleTypeData,
  setParkedBillSearchInput,
  setSearchhistoryInput,
  setCustomerSearchInput,
  setProductSearchInput,
  setSearchTerm,
  setKeyboardInputFields,
  form,
  inputName,
  setLayoutName,
  handleShift,
  onBarcodeInput,
  searchParkedBill,
  parkedBillSearchInput,
  searchOrderHistory,
  searchHistoryInput,
  dateRange,
  handleSelectProduct,
  deleteProduct,
  deleteCart,
  cancelOrder,
  parkBill,
  upsertPOSLog,
  selectLayAwayOrder,
  setIsInputFocused,
  setDataSource,
  dataSource,
  handleSaveReturnCartRecord,
  setDisplayReturnOrderSearch,
  getFilteredPaymentMethods,
  setShowPayments,
  setStartIndex,
  startIndex,
  handleDeletePayment,
  dispatchEvent,
  setPopoverVisible,
  isPopoverVisible,
  getSalesHistoryData,
  expandedRowKeys,
  setExpandedRowKeys,
  isPrintModeXML,
  ObFlag,
  CWHardwareController,
  enableMultiPrintTemplates,
  printTemplates,
  setPendingReprintRecord,
  setSelectedPrintTemplate,
  setShowPrintTemplateModal,
  isOnline,
  domainURL,
  redirectUrl,
  authHeaders,
  isLocked,
  handleLogoutFromHook,
  documentTypes,
  selectedDocumentType,
  setShowDocumentPopup,
  handleSearch,
  setSelectedDate,
  setCalendarVisible,
  searchInputRef,
  setSelectedProductForNotes,
  setNotesPopup,
  calendarVisibleMap,
  setCalendarVisibleMap,
  selectedDate,
  setShowCustomMix,
  keyboardInputFields,
  setIsQuotation,
  setTillLink,
  getProductNearByStock,
  setViewStock,
  selectedPrintTemplate,
  pendingReprintRecord,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { resetProgress } = useSyncProgressStore();
  const returnBillSearchInputRef = useRef();
  // BUG-2066: guards handleLogin against a second invocation (double-click,
  // or a re-render rebinding onClick between clicks) re-running the
  // cookie-clear + navigate sequence — see handleLogin below.
  const loginRedirectStarted = useRef(false);
  const [loadingDetailOrderId, setLoadingDetailOrderId] = useState(null);

  const handleOutsideClick = (event) => {
    const excludedIds = ["sm-parked-bill-customer", "sm-salesHistory-customer", "sm-product-search", "sm-salesHistory-document"];
    if (!excludedIds.includes(event.target?.id) && event.target.offsetParent?.className !== "ant-drawer-content" && event.target.id !== "") {
      setOpen(false);
    }
  };

  const handleKey = (e) => {
    const { altKey, keyCode } = e;
    if (altKey && keyCode === 82) {
      if (posConfig?.showSalesReturn === "Y") {
        setDisplayReturnOrderSearch(true);
      }
    }
  };

  const handleKeyvalue = async (key) => {
    if (key === "0") {
      setSelectedPaymentMethod({});
      setKeyValue("0");
      setSelectedKeys([]);
    }
    if (key === "1") {
      filterdParkedList?.map((item) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item?.parkedCart?.customer?.name || "";
        item.qty = item.parkedCart.totalQty;
      });
      setKeyValue("1");
      setSelectedKeys([]);
    }
    if (key === "2") {
      setKeyValue("2");
      setSelectedKeys([]);
    }
    if (key === "3") {
      showOrderHistory();
      setKeyValue("3");
      setSelectedKeys([]);
    }
    if (key === "4") {
      setSyncLoad(true);
      let td = useAuthStore.getState().tillData;
      const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : td.tillAccess.csBunit.b2cCustomer;
      setCart({ ...cart, customer: defaultCustomer });
      try {
        await processSync(td, "Incremental Sync");
      } catch (e) {
        console.warn("[SuperMarketActions] Incremental sync failed:", e?.message);
        message.error("Sync failed. Please check your network and try again.");
      }
      setSyncLoad(false);
      resetProgress();
    }
    if (key === "7") {
      setKeyValue("7");
      setSelectedKeys([]);
    }
    if (key === "parked-bill") {
      const parkedList = useSessionStore.getState().parkedList || [];
      const updatedParkedList = parkedList.map((item) => ({
        ...item,
        status: "Parked",
        key: uuidv4().replace(/-/g, "").toUpperCase(),
        customer: item?.parkedCart?.customer?.name.toLowerCase(),
        qty: item.parkedCart.totalQty,
      }));
      setFilterdParkedList(updatedParkedList);
      useSessionStore.getState().setParkedList(updatedParkedList);
    }
  };

  const retrieveLayaway = (record) => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Save Cart Items ?",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            You can retrieve the bill later by selecting the 'Retrieve' option in Parked Bills.
            <br />
            Do you want to continue parking the bill?
          </div>
        ),
        okText: "Yes",
        cancelText: "No",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          parkBill();
          upsertPOSLog(cart, "OPK", "Parked");
          const el = document.getElementById("sm-product-search");
          if (el) setTimeout(() => el.focus(), 600);
        },
        onCancel() {
          const el = document.getElementById("sm-product-search");
          if (el) setTimeout(() => el.focus(), 300);
        },
      });
    } else {
      selectLayAwayOrder(record);
    }
  };

  const onKeyPress = (button) => {
    const productSearchInput = document.getElementById("sm-product-search");
    if (button === "{enter}") {
      setLayoutName("default");
      switch (inputName !== "") {
        case inputName === "parkedBill":
          searchParkedBill(parkedBillSearchInput);
          break;
        case inputName === "salesHistoryInput":
          if (searchHistoryInput !== "") {
            setExpandedRowKeys([]);
            searchOrderHistory("customer", searchHistoryInput, 0, dateRange?.length > 0);
          }
          break;
        case inputName === "productSearch":
          onBarcodeInput(productSearchInput?.value, true);
          break;
        case inputName === "productSearch1":
          handleSelectProduct();
        default:
          break;
      }
    } else if (button === "{number}") {
      setLayoutName("number");
    } else if (button === "{numbers}") {
      setLayoutName("numbers");
    } else if (button === "{caps}") {
      setLayoutName("default");
    } else if (button === "{small}") {
      setLayoutName("shift");
    } else if (button === "{shift}" || button === "{lock}") handleShift();
  };

  const onChangeParkedBill = (inputVal) => {
    setParkedBillSearchInput(inputVal);
    keyboard?.current?.setInput(inputVal);
  };

  const updateKeyboardInputs = async (inputs) => {
    if (!inputs) return;
    if (inputName === "customerSearch") setCustomerSearchInput(inputs?.customerSearch || "");
    if (inputName === "productSearch") {
      const searchValue = inputs?.productSearch || "";
      setProductSearchInput(searchValue);
      await handleSearch(searchValue);
    }
    if (inputName === "productSearch1") setProductSearchInput(inputs?.productSearch1 || "");
    if (inputName === "parkedBill") setParkedBillSearchInput(inputs?.parkedBill || "");
    if (inputName === "salesHistoryInput") setSearchhistoryInput(inputs?.salesHistoryInput || "");
    if (inputName === "giftCardInput") setSearchTerm(inputs?.giftCardInput || []);
    if (keyboardInputFields?.type === "addCustomerForm" || keyboardInputFields?.type === "editCustomerForm" || keyboardInputFields?.type === "UAECustomerForm") {
      const customerObj = form?.getFieldsValue(true) || {};
      const updatedFields = { ...customerObj, ...inputs };
      setKeyboardInputFields(updatedFields);
      form?.setFieldsValue(updatedFields);
    }
  };

  const removeProductModal = (record) => {
    // Always close the custom mix drawer first
    setShowCustomMix(false);
    // For empty grouped items (no children), just delete from cart directly (#9)
    // Don't route through any modify/popup flow
    deleteProduct(record);
  };

  const deleteProductModal = () => {
    // In exchange mode, gate checks on the exchange cart instead of the
    // return cart. Ported from roadmap 1ec48549.
    const isExchangeMode = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
    const exchangeCartObj = isExchangeMode ? useCartStore.getState().exchangeCart || null : null;
    const activeCart = isExchangeMode && exchangeCartObj?.items?.length > 0 ? exchangeCartObj : cart;
    if (activeCart.payments?.length > 0) {
      message.warning(`${msgData.errors.cart.delete_payment_first}`);
      return;
    }
    if (activeCart.items.length > 0) {
      Modal.confirm({
        title: "This action will remove all products from the cart, including the selected customer.Do you wish to proceed?",
        icon: null,
        cancelText: "No",
        okText: "Yes",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        async onOk() {
          const { workflowRules, approvers } = await getWorkflowData();
          const cancelParkedBillRule = workflowRules.find((res) => res.eventName === "Cancel Parked Bill");
          if (cancelParkedBillRule && activeCart.parked === "Y" && activeCart.isRetrived === "Y") {
            dispatchEvent(cancelParkedBillRule.eventName, cancelParkedBillRule.ruleName, cancelParkedBillRule.ruleCondition, approvers, null, async (eventData) => {
              if (eventData?.approvalGranted) {
                await cancelOrder();
              } else {
                Modal.error({ title: "Approval Required", content: "The cancellation request was not approved." });
              }
            });
          } else {
            await cancelOrder();
          }
        },
      });
    }
  };

  const pagingCtx = { getFilteredPaymentMethods, cart, posConfig, tillData, startIndex, setShowPayments, setStartIndex, setSelectedPaymentMethod };
  const showMoreItems = () => showNextPaymentPage(pagingCtx);

  const showPreviousItems = () => {};

  // Left/Right arrow keyboard cycling on the payment bar. showPreviousItems
  // above has no real implementation for SuperMarket, and showMoreItems only
  // pages one screenful forward at a time from the current startIndex — neither
  // can jump directly to "whichever page contains payment method N". The shared
  // cyclePaymentMethod computes that window directly so keyboard cycling can
  // move in both directions across the full eligible list.
  const cyclePaymentMethodByKeyboard = (currentMethodId, direction) => cyclePaymentMethod(pagingCtx, currentMethodId, direction);

  const handleSave = (row) => {
    setIsInputFocused(true);
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
    handleSaveReturnCartRecord(newData);
  };

  const handleExpand = async (record) => {
    // Track expansion by sOrderID (guaranteed unique) rather than record.key (=documentno,
    // which can collide across receipts/returns). A shared documentno would otherwise expand
    // every matching row and leave the duplicates rendering blank details. (BUG: Sales History
    // blank/overlapping rows.)
    const nextExpandedKeys = [...expandedRowKeys];
    const index = nextExpandedKeys.indexOf(record.sOrderID);
    if (index > -1) {
      nextExpandedKeys.splice(index, 1);
      setExpandedRowKeys(nextExpandedKeys);
    } else {
      nextExpandedKeys.push(record.sOrderID);
      setExpandedRowKeys(nextExpandedKeys);
      setLoadingDetailOrderId(record.sOrderID);
      try {
        await getSalesHistoryData(record.sOrderID);
      } finally {
        setLoadingDetailOrderId(null);
      }
    }
  };

  const handleExpandPerkedData = (record) => {
    const nextExpandedKeys = [...expandedRowKeys];
    const index = nextExpandedKeys.indexOf(record.key);
    if (index > -1) {
      nextExpandedKeys.splice(index, 1);
    } else {
      nextExpandedKeys.push(record.key);
    }
    setExpandedRowKeys(nextExpandedKeys);
  };

  const handleProductionClick = () => history.push("/production");

  const handleQuotationClick = () => {
    cart.isQuotation = true;
    setCart(cart);
    setIsQuotation(true);
    setTillLink(false);
  };

  const handleViewStockClick = () => {
    getProductNearByStock();
    setViewStock(true);
  };

  const onClose = () => setOpen(false);

  const handleButtonClick = () => setPopoverVisible(!isPopoverVisible);

  const errorMessage = (modalTitle, modalContent) => {
    Modal.error({ title: modalTitle, content: modalContent });
  };

  const tillUnlink = async () => {
    let parkedBills = useSessionStore.getState().parkedList;
    let posConfigLocal = usePOSConfigStore.getState().posConfig;
    const orders = await db.orders.where("isSynced").equals(0).toArray();
    if (posConfigData?.posType === "PRD") {
      try {
        let id = tillData.tillAccess.cwrTill.cwrTillID;
        const response = await unlinkTill(id);
        if (response.data.data.unlinkTill.status === "200") {
          const keepKey = "";
          localStorage.clear();
          await Promise.all(
            db.tables.map(async (table) => {
              if (table.name !== keepKey) await table.clear();
            })
          );
        }
        const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
        for (let i = 0; i < cookiesToDelete.length; i++) {
          const cookie = cookiesToDelete[i];
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          const domain = "domain=" + domainURL;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
        }
        useSessionStore.getState().setUnlink(false);
        window.location.assign("/sign-in");
      } catch (error) {
        console.error("Error in unlinkTillAPI:", error);
      }
    }
    if (parkedBills?.length > 0) {
      message.error(`${t("unlink_till_parked_bill_error")}`);
    } else if (cart?.items?.length > 0) {
      message.error(`${t("unlink_till_cart_error")}`);
    } else if (orders?.length > 0) {
      message.error(`${msgData.errors.till_management.unlink_till_sync_po}`);
    } else {
      if (posConfigLocal?.shiftClose === "Y") {
        useSessionStore.getState().setUnlink(true);
        if (posConfigLocal?.showDenominations === "Y") {
          history.push("/close-till");
        } else if (posConfigLocal?.showCloseTillPaymentSummary === "Y") {
          history.push("/close-till-all");
        } else {
          history.push("/cash-to-keep");
        }
      } else {
        // Clear ALL till state so user is shown the till selection page.
        // setTillValue({}) was wrong — empty object is truthy and Till.js
        // auto-selects when tillValue?.name exists. Use unlinkTill() which
        // sets tillValue to null and clears all related localStorage keys.
        useSessionStore.getState().setTillSession(null);
        useSessionStore.getState().setUnlink(true);
        localStorage.removeItem("tillSession");
        useAuthStore.getState().unlinkTill();
        // Also clear tillRegistrations from IndexedDB so the auto-restore path
        // in Till.js doesn't pick up stale data.
        try {
          await db.tillRegistrations.clear();
        } catch (clearErr) {
          console.warn("[tillUnlink] Failed to clear tillRegistrations:", clearErr);
        }
        history.push("/till");
      }
    }
  };

  const handleLogin = () => {
    if (loginRedirectStarted.current) return;
    loginRedirectStarted.current = true;
    trace("SuperMarket.handleLogin", "invoked", { isOnline, authHeadersUsername: authHeaders?.username, authHeadersHasEmail: !!authHeaders?.email });
    if (isOnline) {
      const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
      for (let i = 0; i < cookiesToDelete.length; i++) {
        const cookie = cookiesToDelete[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        const domain = "domain=" + domainURL;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
      }
      // Persist locked state BEFORE the hard navigation so the sign-in page can
      // route back to /pos (not /till) after re-authenticating.
      useSessionStore.getState().setLocked(true);
      trace("SuperMarket.handleLogin", "navigating", { redirectUrlToSignIn: buildLockedSignInUrl("/", authHeaders), lockedNowSetTo: useSessionStore.getState().locked });
      // IMPORTANT: no trailing slash before `?` — react-router v5 `<Route exact path="/sign-in">`
      // does NOT match `/sign-in/` (with trailing slash), causing a blank page after lock.
      window.location.assign(buildLockedSignInUrl("/", authHeaders));
    } else {
      trace("SuperMarket.handleLogin", "offline — showing error, not navigating");
      errorMessage("Sync Failed", "Please check your network connection and try again");
    }
  };

  const handleLogout = async (logoutLoadingSetter) => {
    await handleLogoutFromHook(logoutLoadingSetter);
  };

  const executeReprint = async (data) => {
    const reprintData = { ...data, isReprint: true };
    const printReprint = () =>
      ObFlag
        ? HCPrint(reprintData, "Duplicate Copy")
        : CWHardwareController
          ? CWHCPrint(reprintData, "Duplicate Copy")
          : isPrintModeXML
            ? xmlPrint(reprintData, "Duplicate Copy")
            : htmlPrint(reprintData, "Duplicate Copy");

    // BUG-2229: gate only on the "Receipt Reprint Request" rule. The old
    // `workflowRules.length > 0` check dropped every till that had other workflow
    // rules but no reprint rule into a forEach that matched nothing and never printed.
    const { workflowRules, approvers } = await getWorkflowData();
    const reprintRule = (workflowRules || []).find((res) => res.eventName === "Receipt Reprint Request");

    if (reprintRule) {
      dispatchEvent(reprintRule.eventName, reprintRule.ruleName, reprintRule.ruleCondition, approvers, null, (eventData) => {
        if (eventData?.approvalGranted) printReprint();
      });
    } else {
      printReprint();
      upsertPOSLog(data, "RRC");
    }
  };

  const handleReceiptReprint = async (record, options = {}) => {
    const { orderCompleted = false } = options;
    const data = orderCompleted ? { ...record, orderCompleted: true } : record;
    let reprintRules = {};
    try {
      reprintRules = posConfig?.reprintRules ? JSON.parse(posConfig.reprintRules) : {};
    } catch (err) {
      console.error("[SMActions] Failed to parse reprintRules:", err);
    }
    let hasServiceItem = false;
    if (reprintRules?.restrict_reprint === true) {
      const rules = reprintRules?.rules || {};
      const restrictedCategories = rules?.categories || [];
      const restrictedProducts = rules?.products || [];
      const hasRestrictedItem = data?.items?.some((item) => {
        const categoryMatch = restrictedCategories.includes(item?.mProductCategoryId);
        const productMatch = restrictedProducts.includes(item?.productId);
        return categoryMatch || productMatch;
      });
      if (hasRestrictedItem) hasServiceItem = true;
    }
    if (!enableMultiPrintTemplates && printTemplates.length > 0 && hasServiceItem) {
      message.warning("Reprint is not allowed for bills containing Service items.");
      return;
    } else if (printTemplates.length > 0) {
      setPendingReprintRecord(data);
      setSelectedPrintTemplate(printTemplates[0]?.cwr_printtemplate_id || null);
      setShowPrintTemplateModal(true);
    } else {
      await executeReprint(data);
    }
  };

  const handlePrintTemplateConfirm = async () => {
    setShowPrintTemplateModal(false);
    useTransactionStore.getState().setSelectedPrintTemplateId(selectedPrintTemplate);
    if (pendingReprintRecord) {
      await executeReprint(pendingReprintRecord);
      setPendingReprintRecord(null);
    }
    setSelectedPrintTemplate(null);
    useTransactionStore.getState().setSelectedPrintTemplateId(null);
  };

  const handlePrintTemplateCancel = () => {
    setShowPrintTemplateModal(false);
    setPendingReprintRecord(null);
    setSelectedPrintTemplate(null);
  };

  const renderInvoice = () => {
    if (posConfig?.enablePreOrder !== "Y" && posConfig?.allowLayawaywithoutPayment !== "Y") {
      return (
        <span
          style={{ fontSize: "0.85rem", cursor: "pointer" }}
          onClick={() => {
            if (posConfig?.enablePreOrder !== "Y") {
              let filtredDocument = documentTypes?.filter((element) => element.type !== selectedDocumentType && element.isVisible);
              if (cart?.docType !== "Advance" && filtredDocument.length > 0) {
                setShowDocumentPopup(true);
              }
            }
          }}
        >
          {selectedDocumentType || "Sales Invoice"} <span style={{ fontSize: "0.7rem" }}>&#9660;</span>
        </span>
      );
    } else if (posConfig?.enablePreOrder !== "Y" && cart.layAway === "Y" && posConfig?.allowLayawaywithoutPayment === "Y") {
      return <span style={{ fontSize: "0.85rem", cursor: "pointer" }}>Layaway</span>;
    } else if (posConfig?.showDocNoOnPOS === "Y") {
      return <span style={{ fontSize: "0.85rem", cursor: "pointer" }}>Order</span>;
    } else {
      return <span style={{ fontSize: "0.85rem", cursor: "pointer" }}>Invoice</span>;
    }
  };

  const renderDocumentNo = () => {
    if (posConfig?.showDocNoOnPOS === "Y") return <span>Document No: {cart?.documentno}</span>;
    if (posConfig?.disableOfflineBilling === "Y") return "";
    return <span>Invoice No: {cart?.documentno}</span>;
  };

  const handleDateSelect = (record) => (date, dateString) => {
    let updatedCart;
    setSelectedDate(date);
    setCalendarVisible(false);
    if (searchInputRef?.current) searchInputRef?.current.focus();
    if (record !== null && cart.items.length > 0) {
      updatedCart = { ...cart };
      let index = updatedCart.items.findIndex((res) => res.lineId === record.lineId);
      if (index >= 0) updatedCart.items[index].deliveryDate = date && date.format("DD-MM-YYYY HH:mm:ss");
      toggleCalendar(record.lineId);
    } else {
      updatedCart = {
        ...cart,
        deliveryDate: (date && date.format("DD-MM-YYYY HH:mm:ss")) || "",
        deliveryDatePromised: (date && dateString) || "",
      };
    }
    setSelectedProductForNotes(null);
    setCart(updatedCart);
    setNotesPopup(false);
    setIsInputFocused(false);
    let orderTimeDetails = usePOSConfigStore.getState().orderTimeDetails || { orderStartTime: "", orderEndTime: "", paymentStartTime: "" };
    if (updatedCart.items.length === 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = { ...orderTimeDetails, paymentStartTime: "", orderStartTime: dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss") };
    } else if (updatedCart.items.length > 0 || tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId !== updatedCart.customer.cwrCustomerId) {
      orderTimeDetails = { ...orderTimeDetails, paymentStartTime: "" };
    }
    if (updatedCart.description === "") {
      orderTimeDetails = { ...orderTimeDetails, paymentStartTime: "", orderStartTime: "" };
    }
    usePOSConfigStore.getState().setOrderTimeDetails(orderTimeDetails);
  };

  const toggleCalendar = (key) => {
    setCalendarVisibleMap((prev) => ({ ...prev, [key]: !prev[key] || false }));
  };

  return {
    handleOutsideClick,
    handleKey,
    handleKeyvalue,
    retrieveLayaway,
    onKeyPress,
    onChangeParkedBill,
    updateKeyboardInputs,
    removeProductModal,
    deleteProductModal,
    showMoreItems,
    showPreviousItems,
    cyclePaymentMethodByKeyboard,
    handleSave,
    modulo,
    handleExpand,
    handleExpandPerkedData,
    handleProductionClick,
    handleQuotationClick,
    handleViewStockClick,
    onClose,
    handleButtonClick,
    errorMessage,
    tillUnlink,
    handleLogin,
    handleLogout,
    executeReprint,
    handleReceiptReprint,
    handlePrintTemplateConfirm,
    handlePrintTemplateCancel,
    renderInvoice,
    renderDocumentNo,
    handleDateSelect,
    toggleCalendar,
    returnBillSearchInputRef,
    loadingDetailOrderId,
  };
};

export default useSuperMarketActions;
